import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'login/checkToken', method: 'POST', body: token })
}
